import { transformRoutes } from '../utils'

export const AdConfigurationAreaRoutes = transformRoutes({
  route: '/marketing-ads-manager',
  Current: {
    route: '',
  },
})
